import {Component, Inject, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl, ValidatorFn} from '@angular/forms';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MxField, MxLabelFn} from '../../services/mxField';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from '../../../../../../shared/services/mx-translate.service';

@Component({
    selector: 'mx-password-field',
    standalone: false,
    templateUrl: './mx-password-field.component.html'
})
export class MxPasswordFieldComponent extends MxField implements OnInit {

    @Input()
    public fieldName: string;
    @Input()
    public retypeLabel: string | MxLabelFn;

    public hidePassword: boolean = true;
    public retypeField: FormControl;
    public passwordField: AbstractControl;

    constructor(public errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    ngOnInit(): void {
        this.passwordField = this.form.get([this.name]);
        this.passwordField.setValidators([this.matchPassword.bind(this), this.passwordField.validator]);
        this.retypeField = new FormControl(null, this.passwordField.validator);
        this.form.addControl(this.name + ' retype', this.retypeField);
    }

    getTooltipValidationMessage = (name?: string): string => {
        let result = this.errorService.getMessages(name ? name : this.name, this.form);
        result = result.map((message) => {
            return this.translateService ? this.translateService.getTranslatedLabel(message): message;
        });
        return result.toString();
    }

    getPasswordValidationMessages(name?: string): string[] {
        return this.errorService.getMessages(name ? name : this.name, this.form);
    }
    getRetypeLabel  = (): string => {
        if (this.retypeLabel) {
            return (typeof this.retypeLabel === 'function')
                ? this.retypeLabel()
                : this.translateService.getTranslatedLabel(this.retypeLabel);
        } else {
            return 'Retype ' + this.getLabel();
        }
    }

    private matchPassword(abstractControl: AbstractControl): ValidatorFn {
        if (abstractControl.parent) {
            let pass = abstractControl.parent.get([this.name]);
            let retype = abstractControl.parent.get([this.name + ' retype']);

            if (pass.value !== retype.value) {
                pass.setErrors({matchPassword: true});
                retype.setErrors({matchPassword: true});
            } else {
                this.updatePasswordValidation(pass);
                this.updatePasswordValidation(retype);
            }
        }
        return null;
    }

    private updatePasswordValidation(control: AbstractControl): void {
        if (control.hasError('matchPassword')) {
            delete control.errors['matchPassword'];
            control.updateValueAndValidity();
        }
    }
}

